import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';
import CircularProgress from '@material-ui/core/CircularProgress';

import Item from './Item';
import Search from './Search';
import { getMaterials } from '../api/api';

const styles = theme => ({
  root: {
    margin: '30px 0px'
  },
  loading: {
    display: 'flex',
    justifyContent: 'center',
    padding: '50px 0'
  }
});

class Materials extends Component {

  state = {
    data: [],
    allMaterials: [],
    loading: true
  }

  async componentDidMount() {
    try {
      const response = await getMaterials();
      const materials = response.items.map(item => ({
        id: item.id,
        image: item.imageUrl,
        link: item.link,
        title: item.description,
        price: item.price || 0
      }));
      this.setState({ data: materials, allMaterials: materials, loading: false });
    } catch (err) {
      console.error('Failed to load materials:', err);
      this.setState({ loading: false });
    }
  }

  update = val => {
    const { allMaterials } = this.state;
    if (val.length >= 3) {
      const filtered = allMaterials.filter(d =>
        d.title.toLowerCase().includes(val.toLowerCase())
      );
      this.setState({ data: filtered });
    } else {
      this.setState({ data: allMaterials })
    }
  }

  render() {
    const { classes } = this.props;
    const { data, loading } = this.state;

    if (loading) {
      return (
        <div className={classes.loading}>
          <CircularProgress />
        </div>
      );
    }

    return (
      <div className={classes.root}>
        <Search onUpdate={this.update} />
        <Grid
          container
          spacing={2}
          direction="row"
          alignItems="flex-start"
        >
          {data.map(material => <Item
                         key={material.id}
                         section={material}
                         purchasable
                         height={180}
                         width={4}
                         type="photo" />
                    )}
        </Grid>
      </div>
    )
  }
}

Materials.propTypes = {
  classes: PropTypes.object.isRequired
}

export default withStyles(styles)(Materials);
